import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { CourseMultiSearch } from "./CourseSearch";
const CourseMultiSearchWrapper = (props) => {
    const [multiSearchData, setMultiSearchData] = React.useState(props.data || null);
    const [, _setCounter] = React.useState(0);
    const forceRerender = () => {
        _setCounter((c) => c + 1);
    };
    return (_jsx(_Fragment, { children: _jsx(CourseMultiSearch, { "aria-label": "Courses", placeholder: props.placeholder, hasActiveCourseSections: true, minNumSearchCharacters: 3, onBlur: () => {
                // Make sure we have the latest version of courses
                forceRerender();
            }, onChange: (val) => setMultiSearchData(val), value: multiSearchData, lookupModal: { isInModal: true }, noOptionsMessage: ({ inputValue }) => {
                if ((inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) < 3) {
                    return "Please type at least 3 characters";
                }
                return "No Options";
            }, maxShown: 200, name: props.name }) }));
};
export default CourseMultiSearchWrapper;
